<form #vacuForm="ngForm" class="flex flex-col gap-[1.35rem] mt-[.5rem] w-full justify-center align-middle sm:max-w-[50rem] sm:min-w-[45rem]">
    
    <div class="flex flex-col">        
        <mat-checkbox [(ngModel)]="shiftForOneDay" [ngModelOptions]="{standalone: true}"> {{"Add shift only for one day" | translate}}</mat-checkbox><br>
        
        <!-- Choose Date -->
        <div class="flex flex-col gap-1 w-full">
            <mat-label>{{"Select a date from" | translate}}</mat-label>
            <mat-form-field appearance="outline" class="flex flex-row items-center">
                <mat-icon matPrefix><i class="fa-regular fa-calendar text-[2rem] pr-[1rem]"></i> </mat-icon>
                <input matInput [matDatepicker]="picker" [(ngModel)]="startingFrom" [min]="yesterday"
                    placeholder='{{"DD/MM/YYYY" | translate}}' #date="ngModel" name="date" required>
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
                <mat-error *ngIf="date && date.errors">
                    <span *ngIf="date.errors['required']">{{"Required Field" | translate}}</span>
                </mat-error>
            </mat-form-field>
        </div>
    
        <div *ngIf="shiftForOneDay === true">
           
             <!-- Choose Employee -->
            <div class="flex flex-col gap-1 w-full">
                <mat-label>{{"Select employee" | translate}}</mat-label>
                <mat-form-field appearance="outline" class="flex flex-row items-center">
                  <mat-icon matPrefix><i class="fa-regular fa-square-user text-[2rem] pr-[1rem]"></i> </mat-icon>
                  
                    <mat-select [(ngModel)]="addPriorityWorkDayConfigs.employeeProfileId" placeholder='{{"Select employee" | translate}}'  
                        name="selectEmployee" #selectEmployee ="ngModel" required>
                        <mat-option *ngFor="let employee of employeeData" [value]="employee.profileId">
                            {{employee.name}} {{employee.surname}}
                        </mat-option>
                    </mat-select>
                    <mat-error *ngIf="selectEmployee && selectEmployee.errors">
                        <span *ngIf="selectEmployee.errors['required']">{{"Required Field" | translate}}</span>
                    </mat-error>
                </mat-form-field>
            </div>
                   
            <!-- Time From -->
            <div class="flex flex-col gap-1 w-full">
                <mat-label>{{"timeFrom" | translate}}</mat-label>
                <mat-form-field appearance="outline" class="flex flex-row items-center">
                  <mat-icon matPrefix><i class="fa-regular fa-clock text-[2rem] pr-[1rem]"></i> </mat-icon>
                  
                  <input type="time" matInput [(ngModel)]="fromTime"  [ngModelOptions]="{standalone: true}" required />
                  <mat-error>
                      <span>{{"Required Field" | translate}}</span>
                  </mat-error>
                </mat-form-field>
            </div>
    
            <!-- Time To -->
            <div class="flex flex-col gap-1 w-full">
                <mat-label>{{"timeTo" | translate}}</mat-label>
                <mat-form-field appearance="outline" class="flex flex-row items-center">
                  <mat-icon matPrefix><i class="fa-regular fa-clock text-[2rem] pr-[1rem]"></i> </mat-icon>
                  
                  <input type="time" matInput [(ngModel)]="toTime" [ngModelOptions]="{standalone: true}" required />
                  <mat-error>
                      <span>{{"Required Field" | translate}}</span>
                  </mat-error>
                </mat-form-field>
            </div>
        </div>
    
        <div *ngIf="shiftForOneDay === false">
    
            <div class="flex flex-col gap-1 w-full">
                <mat-label>{{"Select a date to" | translate}}</mat-label>
                <mat-form-field appearance="outline" class="flex flex-row items-center">
                  <mat-icon matPrefix><i class="fa-regular fa-calendar text-[2rem] pr-[1rem]"></i> </mat-icon>
                  <input matInput [matDatepicker]="secondPicker" [(ngModel)]="endOn" [min]="yesterday"
                    placeholder='{{"DD/MM/YYYY" | translate}}' #endDate="ngModel" name="endDate" required>
                    <mat-datepicker-toggle matSuffix [for]="secondPicker"></mat-datepicker-toggle>
                    <mat-datepicker #secondPicker></mat-datepicker>
                    <mat-error *ngIf="endDate && endDate.errors">
                        <span *ngIf="endDate.errors['required']">{{"Required Field" | translate}}</span>
                    </mat-error>
                </mat-form-field>
            </div>
    
            <mat-divider style="padding-bottom: 2vh;"></mat-divider>
            
            <div class="flex flex-col max-h-[30rem] overflow-y-auto" [ngClass]="{' pr-[1rem]': addShiftModelData.length > 3}">
                <div class="flex flex-col gap-1 w-full" *ngFor="let addShiftModel of addShiftModelData">
                    <mat-label>{{addShiftModel.name}} {{addShiftModel.surname}}</mat-label>
                    <mat-form-field appearance="outline" class="flex flex-row items-center">
                      <mat-icon matPrefix><i class="fa-sharp fa-regular fa-swatchbook text-[2rem] pr-[1rem]"></i> </mat-icon>
                      <mat-select placeholder='{{"Select a template" | translate}}' [(ngModel)]="addShiftModel.shiftTemplateId" name="name" >
                        <mat-option [value]="null"> / </mat-option>
                        <mat-option *ngFor="let template of shiftTemplateData" [value]="template.id"> {{template.name}} </mat-option>
                    </mat-select>
                    </mat-form-field>
                </div>
            </div>
    
        </div>
    </div>

    <div class="flex flex-row gap-10 text-[1rem] sm:text-[1.35rem]">
        <button (click)="closePopup(); $event.preventDefault()" type="button"
            class="w-1/2 px-5 py-[.5rem] uppercase rounded-[.25rem] bg-[#dadada] text-[#696767] hover:bg-[#c4c4c4] shadow-md active:scale-[0.985] active:shadow-sm">
            {{"back" | translate}}
        </button>
    
        <button [disabled]="!vacuForm" [ngClass]="{
                'bg-[#b98d78] hover:bg-[#a57d6a] ': vacuForm,
                'bg-[#b98d78]/20 hover:bg-[#a57d6a]/20': !vacuForm
            }" (click)="createScheduleWithShift()" class="w-1/2 uppercase px-5 py-[.5rem] rounded-[.25rem] text-white shadow-md active:scale-[0.985] active:shadow-sm">
            {{"Add shift" | translate}}
        </button>
    </div>
</form>